import { requestHandler } from "../lib/utils/network-client";

export function getSocialLinks() {
  return requestHandler("/social-links");
}

export function updateSocialLinks(payload) {
  return requestHandler("/social-links", {
    method: "PUT",
    body: payload
  });
}
